<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
      // res.sort((a, b) => {//升序排序，避免显示玫瑰图时后面部分被遮挡
      //   return a.value - b.value
      // })
      // cptData = res;
              newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        processData(cptDataForm,newData,jsFunFlag)
      loadChart(props.option.attribute);

    })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                     let newarr = [];
                      // 遍历原始数组并重组数据
                        res.forEach(item => {
                          let name = item[dataKey[0].value];
                          let valueString = item[dataKey[1].value];
                          let value = Number(valueString); 

                          // 创建新的对象并添加到 aa 数组中
                          newarr.push({ name, value });
                        });
                        console.log(newarr,'新数组')
                          newarr.sort((a, b) => {//升序排序，避免显示玫瑰图时后面部分被遮挡
                             return a.value - b.value
                           })
                        cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                res.sort((a, b) => {//升序排序，避免显示玫瑰图时后面部分被遮挡
                  return a.value - b.value
                })
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
              res.sort((a, b) => {//升序排序，避免显示玫瑰图时后面部分被遮挡
                 return a.value - b.value
              })
              console.log(res,'res')
               cptData = res;
          } 
  }
function loadChart(attr) {
  console.log(attr,'attr')
  if (!cptData) return;
  let legend = JSON.parse(JSON.stringify(attr.legend))
  legend.formatter = function(param) {
    console.log(cptData,'cptData',param)
    let item = cptData.filter(item => item.name === param)[0];
    return  (item !== undefined) ?`${item.name}  ${item.value}` :'';
  }
  let series = getSeries3D(cptData, attr.series.roseType, attr.series.radius)
  //TODO labelLine使用2D方案实现
  chartOption= {
    color: attr.color,
    title: attr.title,
    legend: legend,
    tooltip: {
      show:true,
      formatter: params => {
        return `${params.seriesName}<br/>${cptData[params.seriesIndex].value}`;
      },
      ...attr.tooltip
    },
    xAxis3D: {min: -1, max: 1},
    yAxis3D: {min: -1, max: 1},
    zAxis3D: {min: -1, max: 1},
    grid3D: attr.grid3D,
    series: series
  }
  chart.setOption(chartOption);
}
/**
 *  生成模拟 3D 饼图的配置项
 * @param pieData 饼图数据
 * @param roseType 是否展示玫瑰图
 * @param radius 内环大小0-1
 */
function getSeries3D(pieData, roseType, radius) {
  let series = [];
  let sumValue = 0;
  let startValue = 0;
  let endValue = 0;
  // 为每一个饼图数据，生成一个 series-surface 配置
  for (let i = 0; i < pieData.length; i++) {
    sumValue += pieData[i].value;
    let seriesItem = {
      name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
      type: 'surface',
      parametric: true,
      wireframe: {
        show: false
      },
      pieData: pieData[i],
      pieStatus: {
        selected: false,
        hovered: false,
        k: radius
      }
    };
    series.push(seriesItem);
  }

  let numSum = 0
  pieData.forEach(item => {
    numSum += item.value
  })

  // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
  // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
  for (let i = 0; i < series.length; i++) {
    let height = roseType ? series[i].pieData.value/numSum*10 : 1
    endValue = startValue + series[i].pieData.value;
    series[i].pieData.startRatio = startValue / sumValue;
    series[i].pieData.endRatio = endValue / sumValue;
    series[i].parametricEquation = getParametricEquation(
        series[i].pieData.startRatio,
        series[i].pieData.endRatio,
        false,
        false,
        radius,
        height
    );
    startValue = endValue;
  }
  return series;
}
function getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, height) {
  // 计算
  let midRatio = (startRatio + endRatio) / 2;

  let startRadian = startRatio * Math.PI * 2;
  let endRadian = endRatio * Math.PI * 2;
  let midRadian = midRatio * Math.PI * 2;

  // 如果只有一个扇形，则不实现选中效果。
  if (startRatio === 0 && endRatio === 1) {
    isSelected = false;
  }
  // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
  let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
  let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;

  // 计算高亮效果的放大比例（未高亮，则比例为 1）
  let hoverRate = isHovered ? 1.05 : 1;

  // 返回曲面参数方程
  return {
    u: {
      min: -Math.PI,
      max: Math.PI * 3,
      step: Math.PI / 32
    },

    v: {
      min: 0,
      max: Math.PI * 2,
      step: Math.PI / 20
    },

    x: function(u, v) {
      if (u < startRadian) {
        return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      if (u > endRadian) {
        return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
    },

    y: function(u, v) {
      if (u < startRadian) {
        return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      if (u > endRadian) {
        return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
    },

    z: function(u, v) {
      if (u < -Math.PI * 0.5) {
        return Math.sin(u);
      }
      if (u > Math.PI * 2.5) {
        return Math.sin(u);
      }
      return Math.sin(v) > 0 ? height : -1;
    }
  };
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
